import { UI } from 'common';
import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import MapContactFieldsUtil from '../utils/MapContactFieldsUtil';

const { WrappedDropdownWithLabel, WrappedCheckboxWithLabel } = UI;
class MapContactFieldsRightPanel extends Component {
	constructor(props) {
		super(props);
		const {
			columnsMappedData,
			disabledColumnsData,
			stampsColumnOptions,
			sdcColumnMapping,
			rows,
		} = this.props;
		this.state = {
			selectedRow: 1,
			totalRows: rows,
			isRowOneHeader: true,
			localColumnsMappedData: columnsMappedData,
			localDisabledColumnsData: disabledColumnsData,
			localStampsColumnOptions: stampsColumnOptions,
			localSdcColumnMapping: sdcColumnMapping,
		};
	}

	componentDidUpdate(prevProp) {
		const {
			isTemplateMapped,
			mapContactsCallback,
			isResetAllTriggered,
			columnsMappedData,
		} = this.props;

		if (prevProp.isTemplateMapped !== isTemplateMapped) {
			if (this.isColumnsMapped()) {
				mapContactsCallback({ isMapped: true, isFinalize: true });
			}
		}
		if (prevProp.isResetAllTriggered !== isResetAllTriggered) {
			this.resetSelectedOptions();
		}
		if (!isEqual(prevProp.columnsMappedData, columnsMappedData)) {
			this.refreshState();
		}
	}

	refreshState = () => {
		const {
			columnsMappedData,
			disabledColumnsData,
			stampsColumnOptions,
			sdcColumnMapping,
		} = this.props;

		this.setState({
			localColumnsMappedData: columnsMappedData,
			localDisabledColumnsData: disabledColumnsData,
			localStampsColumnOptions: stampsColumnOptions,
			localSdcColumnMapping: sdcColumnMapping,
		});
	};

	resetSelectedOptions = () => {
		const { localStampsColumnOptions } = this.state;
		const newStampsColumnOptions = localStampsColumnOptions.map(option => {
			option.isMapped = false;
			return option;
		});

		this.setState({
			localStampsColumnOptions: newStampsColumnOptions,
			localSdcColumnMapping: MapContactFieldsUtil.buildDefaultMapping(),
		});
	};

	isColumnsMapped = () => {
		const tempMappedTemplateFields = [];
		const { localSdcColumnMapping } = this.state;

		Object.entries(localSdcColumnMapping).forEach(([columnName, data]) => {
			if (data !== '') {
				tempMappedTemplateFields.push(columnName);
			}
		});

		return tempMappedTemplateFields.length > 0;
	};

	// handle the check box to set row 1 as header
	setRowOneAsHeader = e => {
		const { onIsRowOneHeaderChanged } = this.props;

		this.setState({ isRowOneHeader: e.checked });
		onIsRowOneHeaderChanged({ isRowOneHeader: e.checked });
	};

	getStampsColumnOptions = option => {
		const { stampsColumnOptions } = this.props;
		const { localStampsColumnOptions } = this.state;

		const mappedOptionsIds = localStampsColumnOptions.filter(
			columnOption =>
				columnOption.isMapped &&
				columnOption.id.match(
					/^(FirstNameHeader|MiddleNameHeader|LastNameHeader|PrefixHeader|SuffixHeader)$/
				)
		);

		const isFullNameHeaderMapped =
			localStampsColumnOptions.filter(
				columnOption =>
					columnOption.isMapped && columnOption.id === 'FullNameHeader'
			).length > 0;

		const result = stampsColumnOptions.filter(column => {
			// check if the options is already mapped
			const isNotMapped = !localStampsColumnOptions.some(
				selectedColumns =>
					column.id === selectedColumns.id && selectedColumns.isMapped
			);

			// Filter FullName if FirstNameHeader|MiddleNameHeader|LastNameHeader|PrefixHeader|SuffixHeader is already mapped
			const isFullNameAndDisabled = !(
				column.id === 'FullNameHeader' && mappedOptionsIds.length > 0
			);

			// Filter FirstNameHeader|MiddleNameHeader|LastNameHeader|PrefixHeader|SuffixHeader if  FullName is already mapped
			const isOtheNameOptionsAndDisabled = !(
				column.id.match(
					/^(FirstNameHeader|MiddleNameHeader|LastNameHeader|PrefixHeader|SuffixHeader)$/
				) && isFullNameHeaderMapped
			);

			return (
				option.id === column.id ||
				(isNotMapped && isFullNameAndDisabled && isOtheNameOptionsAndDisabled)
			);
		});

		return result;
	};

	handleColumnChange = (e, resetColumn) => {
		const { name, value, id } = e.target;
		const { mapContactsCallback } = this.props;

		const {
			localSdcColumnMapping,
			localColumnsMappedData,
			localStampsColumnOptions,
		} = this.state;

		const selectedColumn = name === '0' ? 0 : parseInt(name) || parseInt(id);
		const optionSelected = MapContactFieldsUtil.buildInitialOptions()[
			value
		] || {
			id: '-1',
			enabled: true,
		};
		const localSdcMapper = localSdcColumnMapping;
		let oldSelectedOption;

		// This to map or unmap the selected columns
		const newColumnsMappedData = localColumnsMappedData.map(mappedData => {
			if (mappedData.id === selectedColumn) {
				oldSelectedOption = mappedData.option;
				mappedData.option = optionSelected;
				mappedData.isMapped = !resetColumn;
				// reset previous selection
				if (oldSelectedOption && oldSelectedOption.id !== '-1') {
					localSdcMapper[oldSelectedOption.id] = '';
				}
				if (!resetColumn && optionSelected.id !== '-1') {
					localSdcMapper[optionSelected.id] = mappedData.columnName;
				}
			}

			return mappedData;
		});

		// This is to remove the selected options from the dropdown
		const newStampsColumnOptions = localStampsColumnOptions.map(option => {
			if (option.id === value) {
				option.isMapped = !resetColumn;
			} else if (option.id === oldSelectedOption.id) {
				option.isMapped = false;
			}

			return option;
		});

		newColumnsMappedData.sort(function (currentMappedData, nextMappedData) {
			if (
				(currentMappedData.isMapped === nextMappedData.isMapped &&
					nextMappedData.isMapped === true) ||
				(!currentMappedData.isMapped && !nextMappedData.isMapped)
			) {
				return currentMappedData.id < nextMappedData.id ? -1 : 0;
			} else if (currentMappedData.isMapped && !nextMappedData.isMapped) {
				return 1;
			}

			return -1;
		});

		this.setState({
			localSdcColumnMapping: localSdcMapper,
			localColumnsMappedData: newColumnsMappedData,
			localStampsColumnOptions: newStampsColumnOptions,
		});

		mapContactsCallback({
			isMapped: this.isColumnsMapped(),
			newSdcMappedContactFields: localSdcMapper,
		});
	};

	// To handle the column mapping change
	handleColumnMapChange = e => {
		this.handleColumnChange(e, false);
	};

	// To reset the column mapping
	handleResetColumn = e => {
		this.handleColumnChange(e, true);
	};

	// To handle the mapping data row change
	handleRowChange = e => {
		const { id } = e.target;
		const { onRowChanged } = this.props;
		const { selectedRow, totalRows, localStampsColumnOptions } = this.state;
		let newRow = selectedRow;

		if (id === 'previousRow') {
			newRow = selectedRow !== 1 ? selectedRow - 1 : totalRows;
		} else {
			newRow = selectedRow !== totalRows ? selectedRow + 1 : 1;
		}

		this.setState({ selectedRow: newRow });
		onRowChanged(newRow - 1, localStampsColumnOptions);
	};

	render() {
		const {
			selectedRow,
			localColumnsMappedData,
			localDisabledColumnsData,
			isRowOneHeader,
		} = this.state;
		const { stampsColumnOptions } = this.props;

		return (
			<div className="map-contact-fields-right-panel">
				<div className="right-panel-header">
					<div className="left-panel-right-align">
						<div className="panel-headers">Your Uploaded Columns</div>
						<div className="icon-row">
							Row {selectedRow}
							<i
								aria-label="previousRow"
								className="icon-left-arrow"
								id="previousRow"
								onClick={this.handleRowChange}
								role="button"
								tabIndex="0"
							/>
							<i
								aria-label="nextRow"
								className="icon-right-arrow"
								id="nextRow"
								onClick={this.handleRowChange}
								role="button"
								tabIndex="0"
							/>
						</div>
					</div>
					<div className="right-panel-left-align column-header">
						<div className="panel-headers">Stamps.com Columns</div>
					</div>
				</div>
				<hr className="horizontal-line" />
				<div className="scroll-panel">
					{localColumnsMappedData?.map((column, index) =>
						column.enabled ? (
							<React.Fragment key={index}>
								<div key={`row-${index}`} className="column-option-row">
									<div
										key={`label-${index}`}
										className="left-panel-right-align option-center-align"
									>
										{column.text}
									</div>
									<div key={`div-${index}`} className="right-panel-left-align ">
										<WrappedDropdownWithLabel
											className={`mapping-dropdown${
												column.isMapped ? '' : ' mapping-dropdown-highlight'
											}`}
											key={`dropdown-${index}`}
											index
											uiElementConfig={{
												name: column.id.toString(),
												options: this.getStampsColumnOptions(column.option),
												optionLabel: 'name',
												optionValue: 'id',
												dataqa: `dropdown-${column.id}`,
												value: column.option.id,
												placeholder: 'Select a column',
												onChange: this.handleColumnMapChange,
											}}
										/>
										{column.isMapped ? (
											<i
												aria-label={column.id}
												className="icon-reset"
												id={column.id}
												onClick={this.handleResetColumn}
												role="button"
												tabIndex="0"
												key={`icon-${index}`}
											/>
										) : (
											''
										)}
									</div>
								</div>
								{index !== localColumnsMappedData.length - 1 &&
									localColumnsMappedData[index]?.isMapped !==
										localColumnsMappedData[index + 1]?.isMapped && (
										<hr key={`hr-${index}`} className="horizontal-line" />
									)}
							</React.Fragment>
						) : (
							''
						)
					)}
					{localDisabledColumnsData?.length > 0 ? (
						<hr className="horizontal-line" />
					) : (
						''
					)}
					{localDisabledColumnsData?.map((column, index) => (
						<div key={`disabled-row-${index}`} className="column-option-row">
							<div
								key={`disabled-label-${index}`}
								className="left-panel-right-align option-center-align"
							>
								{column.text}
							</div>
							<div
								key={`disabled-div-${index}`}
								className="right-panel-left-align "
							>
								<WrappedDropdownWithLabel
									className="mapping-dropdown"
									key={`disabled-dropdown-${index}`}
									index
									uiElementConfig={{
										name: column.id.toString(),
										disabled: true,
										options: stampsColumnOptions,
										optionLabel: 'name',
										optionValue: 'id',
										dataqa: `disabled-dropdown-${column.id}`,
										value: column.option.id,
										placeholder: 'Select a column',
										onChange: this.handleColumnMapChange,
									}}
								/>
							</div>
						</div>
					))}
				</div>
				<div className="row-header-checkbox">
					<WrappedCheckboxWithLabel
						label="Row 1 is a header"
						showLabelAfter
						uiElementConfig={{
							dataqa: 'options-checkbox-header',
							name: 'headerCheckbox',
							onChange: this.setRowOneAsHeader,
							checked: isRowOneHeader,
						}}
					/>
				</div>
			</div>
		);
	}
}

export default MapContactFieldsRightPanel;
